export default __webpack_public_path__ + "static/media/result.75ddb7d8.svg";